import React, { useEffect } from "react";
import styles from "./Blogs.module.css";

import Blog from "./Blog";
import TitleH2 from "../../../components/TitleH2/TitleH2";
function Blogs() {
  const blogs = [
    {
      id: 1,
      title: "مطلب اول",
      description:
        " بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینیپ",
    },
    {
      id: 2,
      title: "مطلب دوم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 3,
      title: "مطلب سوم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 4,
      title: "مطلب چهارم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 5,
      title: "مطلب پنجم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 6,
      title: "مطلب ششم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 7,
      title: "مطلب هفتم",
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
  ];

  useEffect(() => {}, []);

  return (
    <>
      <section
        id="homePage-blogs__sec"
        className={`${styles.blogsSec} blogs__sec`}>
        <TitleH2>بلاگ ها</TitleH2>
        <div className={`${styles.blogs}`}>
          {blogs.map((b) => (
            <Blog key={b.id} title={b.title} description={b.description} />
          ))}
        </div>
      </section>
    </>
  );
}

export default Blogs;
